import Job from './job';

export default class Queue {
    /** 队列 */
    public queue: Job[] = [];
    /** 当前是否正在执行 */
    public executing: boolean = false;

    public push(job: Job) {
        this.queue.push(job);
        this.handle();
    }
    /** cb将获得resolve和reject两个函数 */
    public promise(cb: (resolve?: any, reject?: any) => any) {
        this.push(Job.promise(cb));
    }

    public async handle() {
        if (!this.executing && this.queue.length > 0) {
            this.executing = true;
            await this.queue.shift()!.execute();
            this.executing = false;
            setImmediate(this.handle.bind(this));
        }
    }
}
